<template>
  <v-container fluid pa-5>
    <SimplePageHeader title="Dashboard" class="px-4 pr-5 mb-5">
      <template v-slot:right-buttons>
        <v-row no-gutters align="center">
          <v-col cols="12">
            <BusinessEntitiesDropDownList
              v-model="selectedBusinessEntityId"
              @businessEntityNameChange="onBusinessEntityNameChange"
              :include-all-business-entities-option="true"
              :hide-details="true"
              :dense="true"
              label="Business Entity"
            ></BusinessEntitiesDropDownList>
          </v-col>
        </v-row>
        </template>
    </SimplePageHeader>
    <v-container fluid>
      <grid-layout
        :layout.sync="dashboardLayoutValue"
        :col-num="12"
        :row-height="30"
        :is-draggable="!isSmallDisplay"
        :is-resizable="!isSmallDisplay"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[5, 5]"
        :use-css-transforms="false"
        :is-bounded="true"
      >
        <grid-item
          v-if="showHeadcountCard"
          :x="headcountCard.x"
          :y="headcountCard.y"
          :w="headcountCard.w"
          :h="headcountCard.h"
          :i="headcountCard.i"
          :key="headcountCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <CurrentHeadCountCard
            ref="headcountTile"
            :business-entity-id="selectedBusinessEntityId"
            :chip-text="getCardChipText(true)"
            :chip-color="getCardChipColor(true)"
          ></CurrentHeadCountCard>
        </grid-item>
        <grid-item
          v-if="showSubmissionsCard"
          :x="submissionsCard.x"
          :y="submissionsCard.y"
          :w="submissionsCard.w"
          :h="submissionsCard.h"
          :i="submissionsCard.i"
          :key="submissionsCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <Submissions
            ref="submissionsTile"
            :chip-text="getCardChipText(false)"
            :chip-color="getCardChipColor(false)"
          ></Submissions>
        </grid-item>
        <grid-item
          v-if="showPlacementGoalCard"
          :x="placementGoalCard.x"
          :y="placementGoalCard.y"
          :w="placementGoalCard.w"
          :h="placementGoalCard.h"
          :i="placementGoalCard.i"
          :key="placementGoalCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <PlacementGoal
            ref="placementGoalTile"
            :business-entity-id="selectedBusinessEntityId"
            :chip-text="getCardChipText(true)"
            :chip-color="getCardChipColor(true)"
          ></PlacementGoal>
        </grid-item>
        <grid-item
          v-if="showPermPlacementGoalCard"
          :x="permPlacementGoalCard.x"
          :y="permPlacementGoalCard.y"
          :w="permPlacementGoalCard.w"
          :h="permPlacementGoalCard.h"
          :i="permPlacementGoalCard.i"
          :key="permPlacementGoalCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <DirectPlacementGoal
            ref="permPlacementGoalTile"
            :chip-text="getCardChipText(false)"
            :chip-color="getCardChipColor(false)"
          ></DirectPlacementGoal>
        </grid-item>
        <grid-item
          v-if="showLERCard"
          :x="lerCard.x"
          :y="lerCard.y"
          :w="lerCard.w"
          :h="lerCard.h"
          :i="lerCard.i"
          :key="lerCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <LaborEfficiencyRatio
            ref="laborEfficiencyRatioTile"
            :business-entity-id="selectedBusinessEntityId"
            :chip-text="getCardChipText(true)"
            :chip-color="getCardChipColor(true)"
          ></LaborEfficiencyRatio>
        </grid-item>
        <grid-item
          v-if="showRevenueCard"
          :x="revenueCard.x"
          :y="revenueCard.y"
          :w="revenueCard.w"
          :h="revenueCard.h"
          :i="revenueCard.i"
          :key="revenueCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <Revenue
            ref="revenueTile"
            :chip-text="getCardChipText(false)"
            :chip-color="getCardChipColor(false)"
          ></Revenue>
        </grid-item>
        <grid-item
          v-if="showNTSCard"
          :x="ntsCard.x"
          :y="ntsCard.y"
          :w="ntsCard.w"
          :h="ntsCard.h"
          :i="ntsCard.i"
          :key="ntsCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <CurrentNtsCard
            ref="ntsTile"
            :business-entity-id="selectedBusinessEntityId"
            :chip-text="getCardChipText(true)"
            :chip-color="getCardChipColor(true)"
          ></CurrentNtsCard>
        </grid-item>
        <grid-item
          v-if="showNTSByEmployeeCard"
          :x="ntsByEmployeeCard.x"
          :y="ntsByEmployeeCard.y"
          :w="ntsByEmployeeCard.w"
          :h="ntsByEmployeeCard.h"
          :i="ntsByEmployeeCard.i"
          :key="ntsByEmployeeCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <NtsByEmployee
            ref="ntsByEmployeeTile"
            :business-entity-id="selectedBusinessEntityId"
            :chip-text="getCardChipText(true)"
            :chip-color="getCardChipColor(true)"
          ></NTSbyEmployee>
        </grid-item>
        <grid-item
          v-if="showInterviewsCard"
          :x="interviewsCard.x"
          :y="interviewsCard.y"
          :w="interviewsCard.w"
          :h="interviewsCard.h"
          :i="interviewsCard.i"
          :key="interviewsCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <UpcomingInterviews
            ref="upcomingInterviewsTile"
            :chip-text="getCardChipText(false)"
            :chip-color="getCardChipColor(false)"
          ></UpcomingInterviews>
        </grid-item>
        <grid-item
          v-if="showGrossProfitCard"
          :x="grossProfitCard.x"
          :y="grossProfitCard.y"
          :w="grossProfitCard.w"
          :h="grossProfitCard.h"
          :i="grossProfitCard.i"
          :key="grossProfitCard.i"
          @moved="movedEventHandler"
          @resized="resizedEventHandler"
        >
          <GrossProfitTile
            ref="grossProfitTile"
            :business-entity-id="selectedBusinessEntityId"
            :chip-text="getCardChipText(true)"
            :chip-color="getCardChipColor(true)"
          ></GrossProfitTile>
        </grid-item>
      </grid-layout>
    </v-container>
  </v-container>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import CurrentHeadCountCard from './headCount/CurrentHeadCountCard'
import CurrentNtsCard from './nts/CurrentNtsCard'
import { UpcomingInterviews } from '@/components/dashboard/interviews'
import { PlacementGoal } from '@/components/dashboard/placementGoal'
import { DirectPlacementGoal } from '@/components/dashboard/directPlacementGoal'
import { Submissions } from '@/components/dashboard/submissions'
import LaborEfficiencyRatio from '@/components/dashboard/laborEfficiencyRatio/LaborEfficiencyRatio'
import { Revenue } from '@/components/dashboard/revenue'
import VueGridLayout from 'vue-grid-layout'
import { getCurrentUser, getCurrentUserId, userHasRoles, userIsAdmin } from '@/lib/authentication'
import { allRolesList as RolesList } from '@/lib/constants/securityRoles'
import { consultantTimeSheetRoute, clockLogsRoute, defaultRoute } from '@/lib/constants/routes'
import { GrossProfitTile } from '@/components/dashboard/grossProfitTile'
import NtsByEmployee from './ntsByEmployee/NtsByEmployee'
import { BusinessEntitiesDropDownList } from '@/components/businessEntities'
import { ALL_BUSINESS_ENTITIES } from '@/lib/constants/businessEntities'

export default {
  components: {
    SimplePageHeader,
    CurrentHeadCountCard,
    CurrentNtsCard,
    NtsByEmployee,
    UpcomingInterviews,
    PlacementGoal,
    DirectPlacementGoal,
    Submissions,
    LaborEfficiencyRatio,
    Revenue,
    GrossProfitTile,
    BusinessEntitiesDropDownList,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  },
  data () {
    return {
      localDashboardLayoutXS: [],
      LaborEfficiencyRatioData: null,
      selectedBusinessEntityId: ALL_BUSINESS_ENTITIES,
      selectedBusinessEntityName: 'All Business Entities'
    }
  },
  watch: {
    currentDashboardLayout () {
      if (!this.isSmallDisplay) {
        this.dashboardLayoutValue = this.currentDashboardLayout
      }
    },
    selectedBusinessEntityId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$nextTick(() => {
          this.refreshBusinessEntityFilteredTiles()
        })
      }
    }
  },
  computed: {
    ...mapFields('settings', ['dashboardSettings']),
    ...mapFields('dashboardLayout', [
      'defaultDashboardLayout',
      'defaultDashboardLayoutXS',
      'currentDashboardLayout'
    ]),
    dashboardLayoutValue: {
      get () {
        if (this.isSmallDisplay) {
          return this.localDashboardLayoutXS
        } else {
          return this.currentDashboardLayout
        }
      },
      set (newValue) {
        if (!this.isSmallDisplay) {
          this.currentDashboardLayout = newValue
        }
      }
    },
    showHeadcountCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('headCount') })
      }
    },
    headcountCard: {
      get () {
        return this.getLayoutItem('headcount')
      }
    },
    showSubmissionsCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('submissions') })
      }
    },
    submissionsCard: {
      get () {
        return this.getLayoutItem('submissions')
      }
    },
    showPlacementGoalCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('placementGoal') })
      }
    },
    placementGoalCard: {
      get () {
        return this.getLayoutItem('placement_goal')
      }
    },
    showPermPlacementGoalCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('permPlacementGoal') })
      }
    },
    permPlacementGoalCard: {
      get () {
        return this.getLayoutItem('perm_placement_goal')
      }
    },
    showLERCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('ler') })
      }
    },
    lerCard: {
      get () {
        return this.getLayoutItem('ler')
      }
    },
    showRevenueCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('revenue') })
      }
    },
    revenueCard: {
      get () {
        return this.getLayoutItem('revenue')
      }
    },
    showNTSCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('nts') })
      }
    },
    ntsCard: {
      get () {
        return this.getLayoutItem('nts')
      }
    },
    showNTSByEmployeeCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('ntsByEmployee') })
      }
    },
    ntsByEmployeeCard: {
      get () {
        return this.getLayoutItem('nts_by_employee')
      }
    },
    showInterviewsCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('interviews') })
      }
    },
    interviewsCard: {
      get () {
        return this.getLayoutItem('interviews')
      }
    },
    showGrossProfitCard: {
      get () {
        return userHasRoles({ user: getCurrentUser(), allowedRoles: this.getDashboardCardAccess('grossProfit') })
      }
    },
    grossProfitCard: {
      get () {
        return this.getLayoutItem('grossProfit')
      }
    },
    isSmallDisplay () {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  methods: {
    ...mapActions('dashboardLayout', [
      'getDashboardLayoutItems',
      'saveDashboardLayout'
    ]),
    ...mapActions('settings', ['getSettings']),
    ...mapActions('assignments', [
      'getAssignmentsByUserId'
    ]),
    onBusinessEntityNameChange (businessEntityName) {
      this.selectedBusinessEntityName = businessEntityName || 'All Business Entities'
    },
    getCardChipColor (isBusinessEntityFilterable) {
      if (!isBusinessEntityFilterable || this.selectedBusinessEntityId === ALL_BUSINESS_ENTITIES || this.selectedBusinessEntityId === null || this.selectedBusinessEntityId === undefined) {
        return 'primary'
      }

      return 'success'
    },
    getCardChipText (isBusinessEntityFilterable) {
      if (!isBusinessEntityFilterable || this.selectedBusinessEntityId === ALL_BUSINESS_ENTITIES || this.selectedBusinessEntityId === null || this.selectedBusinessEntityId === undefined) {
        return 'All Business Entities'
      }

      return `${this.selectedBusinessEntityName} Only`
    },
    getLayoutItem (id) {
      let item = this.dashboardLayoutValue.find(item => item.i === id)
      if (!item) {
        return { i: id, x: 0, y: 0, w: 0, h: 0 }
      }
      return item
    },
    getDashboardCardAccess (card) {
      let rolesList = []
      let allowedRoles = this.dashboardSettings[card]
      if (allowedRoles && allowedRoles.length > 0) {
        for (const role of allowedRoles) {
          let roleConstant = RolesList.find(i => i.name === role)
          if (roleConstant) {
            rolesList.push(roleConstant)
          }
        }
      }
      return rolesList
    },
    movedEventHandler () {
      this.saveDashboardLayout()
    },
    resizedEventHandler () {
      this.saveDashboardLayout()
    },
    getInitialLayout (layout) {
      let finalLayout = []
      if (this.showHeadcountCard) {
        finalLayout.push(layout.find(item => item.i === 'headcount'))
      }
      if (this.showNTSCard) {
        finalLayout.push(layout.find(item => item.i === 'nts'))
      }
      if (this.showNTSByEmployeeCard) {
        finalLayout.push(layout.find(item => item.i === 'nts_by_employee'))
      }
      if (this.showSubmissionsCard) {
        finalLayout.push(layout.find(item => item.i === 'submissions'))
      }
      if (this.showPlacementGoalCard) {
        finalLayout.push(layout.find(item => item.i === 'placement_goal'))
      }
      if (this.showPermPlacementGoalCard) {
        finalLayout.push(layout.find(item => item.i === 'perm_placement_goal'))
      }
      if (this.showLERCard) {
        finalLayout.push(layout.find(item => item.i === 'ler'))
      }
      if (this.showRevenueCard) {
        finalLayout.push(layout.find(item => item.i === 'revenue'))
      }
      if (this.showInterviewsCard) {
        finalLayout.push(layout.find(item => item.i === 'interviews'))
      }
      if (this.showGrossProfitCard) {
        finalLayout.push(layout.find(item => item.i === 'grossProfit'))
      }
      return finalLayout
    },
    getInitialLayoutXS () {
      let finalLayoutXS = []
      if (this.showHeadcountCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'headcount'))
      }
      if (this.showNTSCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'nts'))
      }
      if (this.showNTSByEmployeeCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'nts_by_employee'))
      }
      if (this.showSubmissionsCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'submissions'))
      }
      if (this.showPlacementGoalCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'placement_goal'))
      }
      if (this.showPermPlacementGoalCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'perm_placement_goal'))
      }
      if (this.showLERCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'ler'))
      }
      if (this.showRevenueCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'revenue'))
      }
      if (this.showInterviewsCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'interviews'))
      }
      if (this.showGrossProfitCard) {
        finalLayoutXS.push(this.defaultDashboardLayoutXS.find(item => item.i === 'grossProfit'))
      }
      return finalLayoutXS
    },
    refreshBusinessEntityFilteredTiles () {
      if (this.showHeadcountCard && this.$refs.headcountTile) {
        this.$refs.headcountTile.refreshTile()
      }
      if (this.showNTSCard && this.$refs.ntsTile) {
        this.$refs.ntsTile.refreshTile()
      }
      if (this.showNTSByEmployeeCard && this.$refs.ntsByEmployeeTile) {
        this.$refs.ntsByEmployeeTile.refreshTile()
      }
      if (this.showPlacementGoalCard && this.$refs.placementGoalTile) {
        this.$refs.placementGoalTile.refreshTile()
      }
      if (this.showLERCard && this.$refs.laborEfficiencyRatioTile) {
        this.$refs.laborEfficiencyRatioTile.refreshTile()
      }
      if (this.showGrossProfitCard && this.$refs.grossProfitTile) {
        this.$refs.grossProfitTile.refreshTile()
      }
    }
  },
  async created () {
    await this.getSettings().then(async () => {
      // Redirect if the user doesn't have permission to view any card.
      if (!userIsAdmin() && (
        !this.showGrossProfitCard &&
        !this.showHeadcountCard &&
        !this.showSubmissionsCard &&
        !this.showPlacementGoalCard &&
        !this.showPermPlacementGoalCard &&
        !this.showLERCard &&
        !this.showRevenueCard &&
        !this.showNTSCard &&
        !this.showNTSByEmployeeCard &&
        !this.showInterviewsCard
      )) {
        if (getCurrentUser().staffEmployeeId != null && getCurrentUser().staffNeedTimeSheet) {
          this.$router.push({ name: consultantTimeSheetRoute.name })
        } else {
          let assignmentsList = await this.getAssignmentsByUserId(getCurrentUser().id)
          let firstAssignment = assignmentsList && assignmentsList.length > 0 ? assignmentsList[0] : null
          if (!firstAssignment) {
            this.$router.push({ name: defaultRoute.name })
          } else if (firstAssignment.timeSheetType === 2) { // Normal Time Sheet
            this.$router.push({ name: consultantTimeSheetRoute.name })
          } else if (firstAssignment.timeSheetType === 3) { // Clock In / Clock Out
            this.$router.push({ name: clockLogsRoute.name })
          } else {
            this.$router.push({ name: defaultRoute.name })
          }
        }
      } else {
        this.getDashboardLayoutItems(getCurrentUserId()).then(layout => {
          if (layout && layout.length > 0) {
            this.currentDashboardLayout = this.getInitialLayout(layout)
          } else {
            this.currentDashboardLayout = this.getInitialLayout(this.defaultDashboardLayout)
          }
          this.localDashboardLayoutXS = this.getInitialLayoutXS()
        })
      }
    })
  }
}
</script>

<style>
.vue-grid-item.vue-grid-placeholder {
  background: #003F97 !important;
}
</style>
